import {callApi, uploadApi} from './Api';
import './Global';

/**
 *
 * @param{email, password)data
 */
export const createClient = async(requestData={}) => {
    const functionUrl = "client";
    try {
        return await callApi(functionUrl, requestData )
            .then((response) => {
                return response;
            })
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{email, password)data
 */
export const clientList = async( requestData = {} ) => {
    const functionUrl = "clientList";

    try {
        return await callApi(functionUrl, requestData )
            .then((response) => {
                return response;
            })
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{get single client) by id
 */
export const updateClient = async(requestData, id) => {
    const functionUrl = "client";
    try {
        return await callApi(functionUrl, requestData, 'PUT', id )
            .then((response) => {
                return response;
            })
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};


/**
 *
 * @param{delete client) by id
 */
export const deleteClient = async(id) => {
    const functionUrl = "client";
    try {
        return await callApi(functionUrl, {}, 'DELETE', id )
            .then((response) => {
                return response;
            })
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 *
 * @param{get single client) by id
 */
export const getClient = async(id) => {
    const functionUrl = "client";
    try {
        return await callApi(functionUrl, {}, 'GET', id)
            .then((response) => {
                return response;
            })
    } catch (error) {
        // console.log("Error from catch => ", error);
    }
};

/**
 * Common Api for upload file or profile pic.
 * @param(file, callback) 
 * @return API response
*/
export const uploadFile = async (file, callBack, type) => {
	const functionUrl = 'clientImageUpload';
	try {
		const response = await uploadApi(functionUrl, file, callBack, type);
		if (response) {
			return callBack(response);
		}
	} catch (error) {
		// console.log('Error from catch => ', error);
	}
}

